module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('home-page')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-91471a58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Layouts/HomeLayout.vue
// module id = 407
// module chunks = 1